import { AppForm } from '../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ApplicationAppEntityApplicationWrite } from '../../../../../../openapi';

@Injectable()
export class AgreementForm extends AppForm {
  constructor() {
    super({
      clause: new FormControl(false, { validators: [Validators.requiredTrue], nonNullable: true })
    });
  }

  public toWriteModel(): ApplicationAppEntityApplicationWrite {
    return {
      regulations: this.value.regulations,
      clause: this.value.clause
    };
  }
}
